/* storybook-check-ignore */
import { withRouter } from 'next/router';
import { WithRouterProps } from 'next/dist/client/with-router';
import { Box } from '@opendoor/bricks/core';

import ReduxWrapper from '../../components/shared/ReduxWrapper';
import DefaultLayout from '../../components/exclusives/layouts/DefaultLayout';
import AccountFormPage from '../../components/exclusives/ExclusivesAccountFormPage';

export default withRouter(({ router }: WithRouterProps) => (
  <ReduxWrapper>
    <DefaultLayout headerProps={{ isSearchHidden: true }} hideHeaderNavLinks={true} loadHotjar>
      <Box maxWidth="552" mx="auto" padding={[7, 7, 0]} height="calc(100% - 4.2rem)">
        <AccountFormPage {...router.query} />
      </Box>
    </DefaultLayout>
  </ReduxWrapper>
));
